interface Props {
    text: string;
}

/**
 * Inline laterality reminder shown directly as the first line of a question page, above the page title (always left aligned), e.g.
 *   Answering for Left side
 * The side is emphasised with colour and an underline accent.
 *
 * Accepts the raw banner string from formatTrackerLateralityBanner, which
 * looks like: "Answer for your left side." - we reshape it into the
 * patient-friendly progressive "Answering for ..." form.
 */
const InlineLateralityLine = ({ text }: Props) => {
    const match = text.match(/^.*?\b(left|right)\s+(.+?)\.?$/i);
    const sideRaw = match?.[1];
    const areaRaw = match?.[2];

    if (!sideRaw || !areaRaw) {
        return (
            <p
                data-anno="laterality"
                className="mb-3 font-medium text-primary text-lg text-left decoration-2 decoration-primary/50 underline underline-offset-[5px] leading-snug"
                role="status"
            >
                {text}
            </p>
        );
    }

    const side = sideRaw.charAt(0).toUpperCase() + sideRaw.slice(1).toLowerCase();
    const area = areaRaw.toLowerCase();

    return (
        <p
            data-anno="laterality"
            className="mb-3 text-slate-600 dark:text-slate-400 text-lg text-left leading-snug"
            role="status"
        >
            Answering for{" "}
            <span className="font-semibold text-primary decoration-2 decoration-primary/60 underline underline-offset-[5px]">
                {side} {area}
            </span>
        </p>
    );
};

export default InlineLateralityLine;
